import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getTimeIntervals () {
    return Api()
      .get('v1/admin/variantManagement/timeIntervals')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.GetTimeIntervalsErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getVariantHandlerOptions () {
    return Api()
      .get('v1/admin/variantManagement/handlerOptions')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.GetVariantHandlerOptionsErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async create (variant) {
    return Api()
      .post('v1/admin/variantManagement', {
        uid: '00000000-0000-0000-0000-000000000000',
        productUid: variant.productUid,
        name: variant.name,
        externalSku: variant.externalSku,
        minimumOrderAmount: variant.minimumOrderAmount,
        recurring: variant.recurring,
        recurringTimeInterval: variant.recurring ? variant.recurringTimeInterval : null,
        recurringIntervalQuantity: variant.recurring ? variant.recurringIntervalQuantity : null,
        prepaid: !!variant.prepaid,
        prepaidTimeInterval: variant.prepaid ? variant.prepaidTimeInterval : null,
        prepaidIntervalQuantity: variant.prepaid ? variant.prepaidIntervalQuantity : null,
        msrp: variant.msrp,
        daysTrial: variant.daysTrial,
        coterminationAllowed: variant.coterminationAllowed,
        // displayTemplateAlias: variant.displayTemplateAlias,
        published: variant.published,
        handler: variant.handler,
      })
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.CreateVariantSuccessMessage', [variant.name]),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.CreateVariantErrorMessage', [variant.name]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async update (variant) {
    var updatedVariant = {
      uid: variant.uid,
      productUid: variant.productUid,
      name: variant.name,
      externalSku: variant.externalSku,
      minimumOrderAmount: variant.minimumOrderAmount,
      recurring: variant.recurring,
      recurringTimeInterval: variant.recurring ? variant.recurringTimeInterval : null,
      recurringIntervalQuantity: variant.recurring ? variant.recurringIntervalQuantity : null,
      prepaid: !!variant.prepaid,
      prepaidTimeInterval: variant.prepaid ? variant.prepaidTimeInterval : null,
      prepaidIntervalQuantity: variant.prepaid ? variant.prepaidIntervalQuantity : null,
      msrp: variant.msrp,
      daysTrial: variant.daysTrial,
      coterminationAllowed: variant.coterminationAllowed,
      // displayTemplateAlias: variant.displayTemplateAlias,
      published: variant.published,
      handler: variant.handler,
    }

    return Api()
      .put('v1/admin/variantManagement', updatedVariant)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.UpdateVariantSuccessMessage', [variant.name]),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.UpdateVariantErrorMessage', [variant.name]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
    },
  async delete (productVariant) {
    return Api()
      .delete(`v1/admin/variantManagement/${productVariant.productUid}/?productVariantUid=` + productVariant.uid)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.DeleteVariantSuccessMessage'),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(function (error) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Variant.Messages.DeleteVariantErrorMessage', [productVariant.uid.substr(0, 6)]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
